import{createGlobalStyle as t}from"styled-components";const e=t`
  body {
    font: 12px/18px 'メイリオ', Meiryo, 'ＭＳ Ｐゴシック', 'MS PGothic', 'ヒラギノ角ゴ Pro W3',
      'Hiragino Kaku Gothic Pro', Osaka, sans-serif, 'Lucida Grande', 'Lucida Sans Unicode', Helvetica,
      Arial, Verdana;
    margin: 0px;
    padding: 0px;
    color: #222222;
    height: auto;
    background: url(./images/header_blue.png);
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    transition: background-color 5000s ease-in-out 0s;
  }
`;export{e as GlobalStyle};
